import React, { useState, useEffect } from "react";
import GainIcon from "../../components/gainicon";
import GainSelect from "../../components/objects/GainSelect";
import GainButton from "../../components/objects/GainButton";

import {
  Form,
  Upload,
  Card,
  Space,
  Input,
  Select,
  message,
  Button,
} from "antd";
import UploadFile from "../../components/UploadFile";

import {
  getEmissionType,
  getScenarios,
  getUsers,
  createScenario,
} from "../../services/api";
import { baseURL } from "../../config";

import moment from "moment";

const { TextArea } = Input;
const { Option, OptGroup } = Select;

export default function Index() {
  const [form] = Form.useForm();

  const [ExcelFile, setExcelFile] = useState(null);
  const [Template, setTemplate] = useState([]);
  const [Scenario, setScenario] = useState([]);
  const [UserListsOption, setUserListsOption] = useState([]);
  const [File, setFile] = useState(null);

  useEffect(() => {
    scenarioLists();
    userLists();
  }, []);

  const scenarioLists = async () => {
    const res = await getScenarios();
    setScenario(res.data);
  };

  const userLists = async () => {
    const res = await getUsers();
    const option = res.data.data.map((item) => ({
      id: item.id,
      name: `Uploading for ${item.firstname}`,
      value: item.id,
    }));
    setUserListsOption(option);
  };

  const handleSubmit = async (value) => {
    const res = await createScenario(value);
    if (res.status === 200) {
      message.success("Add success");
      scenarioLists();
      userLists();
      form.resetFields();
      setFile(null);
    } else {
      message.error(res.message);
    }
  };

  return (
    <div>
      {/* {console.log(form)} */}
      <h1 className="text-3xl font-bold">Data Management</h1>
      <div className="grid grid-cols-3 2xl:grid-cols-4 gap-6 pt-8">
        <Card
          title="Download"
          className="border-none rounded-lg pb-6 col-span-2 2xl:col-span-3"
        >
          <div className="px-6">
            <Select
              placeholder="Select"
              onChange={(value) => setExcelFile(value)}
              dropdownClassName="rounded-lg"
              className="text-black w-full text-base font-light pt-1"
              suffixIcon={<GainIcon name="arrow-down" />}
            >
              <OptGroup label="Template" key={1}>
                {Template.map((option) => (
                  <Option value={option.value}>{option.name}</Option>
                ))}
              </OptGroup>
              <OptGroup label="Created By" key={2}>
                {Scenario.map((option) => (
                  <Option value={option.file_name}>
                    {option.scenario_name}{" "}
                    <span className="text-purple-500">
                      by {option.owner.firstname}{" "}
                      {`(${moment(option.created_at)
                        .subtract(10, "days")
                        .calendar()})`}
                    </span>
                  </Option>
                ))}
              </OptGroup>
            </Select>
            <div className="pt-12 w-full pb-4">
              <a href={`${baseURL}/api/excel/download/${ExcelFile}`} download>
                <GainButton label="Get File Excel" center />
              </a>
            </div>
          </div>
        </Card>
        <Card className="border-none rounded-lg px-6 py-3">
          <div className="flex justify-between items-center pb-3">
            <h1 className="font-bold text-base">Upload data</h1>
            <div
              className="cursor-pointer"
              onClick={() => {
                form.resetFields();
                setFile(null);
              }}
            >
              <GainIcon name="refresh" />
            </div>
          </div>
          <Space direction="vertical">
            <Form onFinish={handleSubmit} form={form}>
              <Form.Item
                name="scenario_name"
                rules={[
                  { required: true, message: "Please input scinario name!" },
                ]}
              >
                <Input
                  className="rounded-lg py-2.5 border-gray-200 font-light"
                  placeholder="Input scinario name"
                  allowClear
                />
              </Form.Item>
              <Form.Item
                name="owner_id"
                rules={[{ required: true, message: "Please select owner!" }]}
              >
                <GainSelect options={UserListsOption} nospace />
              </Form.Item>

              <Form.Item name="description">
                <TextArea
                  rows={3}
                  className="rounded-lg 
          border-gray-200"
                  placeholder="Desription"
                  allowClear
                  autoSize={{ minRows: 3, maxRows: 5 }}
                />
              </Form.Item>
              <UploadFile value={File} onChange={setFile} />
              <GainButton
                className="mt-6"
                label="Upoad"
                center
                htmlType="submit"
              />
            </Form>
          </Space>
        </Card>
      </div>
    </div>
  );
}
